/** 仅 DBG 浮窗：不解密验签，只解析 JWT payload */
export function decodeJwtPayloadUnsafe(
  token: string | null | undefined
): Record<string, unknown> | null {
  if (!token || typeof token !== "string") return null;
  const parts = token.split(".");
  if (parts.length !== 3) return null;
  try {
    const b64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const pad = b64.length % 4 === 0 ? "" : "=".repeat(4 - (b64.length % 4));
    const json = globalThis.atob(b64 + pad);
    return JSON.parse(json) as Record<string, unknown>;
  } catch {
    return null;
  }
}

export function formatJwtExpHint(payload: Record<string, unknown> | null): string {
  if (!payload) return "—";
  const exp = payload.exp;
  if (typeof exp !== "number") return "—";
  const ms = exp * 1000;
  const d = new Date(ms);
  const iso = d.toISOString();
  if (ms < Date.now()) return `${iso}（已过期）`;
  return `${iso}（未过期）`;
}
